import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MatPaginator} from '@angular/material/paginator';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {BannerSponsorService} from '../services/banner-sponsor.service';
import { FormGroup, FormBuilder} from '@angular/forms';
import {BannerDialogComponent} from '../event/dialogs/banner-dialog/banner-dialog.component';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';

@Component({
    selector: 'app-banner-sponsor',
    templateUrl: './banner-sponsor.component.html',
    styleUrls: ['./banner-sponsor.component.scss'],
    entryComponents: [
        BannerDialogComponent,
        ConfirmComponent
    ]
})

export class BannerSponsorComponent implements OnInit {

    public sponsorsDataSource: MatTableDataSource<any>
    public displayedSponsorColumns: string[] = ['image', 'link', 'delete'];
    public currentSponsor: any;


    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor (
        private fs: AngularFireStorage,
        private _bannerSponsorService: BannerSponsorService,
        private dialog: MatDialog,
        private snackBar: SnackBarIconService,
        private fb: FormBuilder) {
        this.loadBannerSponsors();
    }

    ngOnInit () {

    }

    ngOnDestroy () {

    }


    loadBannerSponsors () {
        this._bannerSponsorService.getUnique()
            .subscribe((result) => {

                this.currentSponsor = result.data()
                this.sponsorsDataSource = new MatTableDataSource(this.currentSponsor.sponsors);

            })
    }



    openDialog () {

        let dialogRef = this.dialog.open(BannerDialogComponent, {
            width: '600px',
            height: '470px',
            hasBackdrop: true,
            disableClose: true,
            panelClass: 'custom-dialog-container',
            data: {'isProduct': false}
        })

        dialogRef.afterClosed()
            .subscribe(response => {
                if (!response) {
                    return;
                }

                const bannerForm: FormGroup = response[0];
                const objectBanner: any = response[1];

                const formData = bannerForm.getRawValue();

                let banner: any = {};

                banner.id = new Date().getTime();
                banner.link = formData.link || '';

                const fsRef: AngularFireStorageReference = this.fs.ref("images/banner_sponsors/" + "banner_" + banner.id + ".png");
                const fsTask: AngularFireUploadTask = fsRef.put(objectBanner);

                fsTask.snapshotChanges().pipe(
                    finalize(() => {
                        fsRef.getDownloadURL().subscribe(url => {
                            banner.image = url;
                            this.updateBannerSponsor(banner);
                        });
                    }))
                    .subscribe();
            })
    }

 

   
    updateBannerSponsor (banner) {

        this.currentSponsor.sponsors.push(banner)

        this.sponsorsDataSource = new MatTableDataSource(this.currentSponsor.sponsors)

        this._bannerSponsorService.updateBannerSponsor( this.currentSponsor.sponsors)

    }

    removeBannerSponsor (element) {

        let dialogRef = this.dialog.open(ConfirmComponent, {
            width: '350px',
            height: '270px',
            panelClass: 'custom-dialog-container',
            data: {title: "Confirme", message: element.link + "<br><br>Excluir este banner?"}
        });

        dialogRef.afterClosed().subscribe(result => {

            if (result == "ok") {
                this.currentSponsor.sponsors = this.currentSponsor.sponsors.filter((e) => {
                    return e.id != element.id;
                })

                this.sponsorsDataSource = new MatTableDataSource(this.currentSponsor.sponsors)
                this._bannerSponsorService.updateBannerSponsor(this.currentSponsor.sponsors)
                .then(()=>{

                    const fsRef: any = this.fs.storage.refFromURL(element.image);
                    fsRef.delete();

                })

            }
            else {
                return result
            }

        })


    }

    
}
